import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Quote } from './Quote';
import { QuoteDetail } from './QuoteDetail';
import { Fee } from './Fee';
import { Distributor } from './Distributor';
import { Territory } from './Territory';
import { SalesPerson } from './SalesPerson';
import { formatCurrency } from '@angular/common';

export class QuoteReport {
  public constructor() {

  }

  public CreateQuoteReport(CurrentQuote: Quote,SelectedCustomer:string,SelectedTerritory:string,SelectedRSM:string,CustType:string) {
    var pdfGen = new jsPDF();
    pdfGen.setProperties({ title: CurrentQuote.QuoteNumber });

    //pdfGen.setHeaderFunction(function (doc) {
    //  doc.setFontSize(10);
    //  doc.addImage(getBase64ImageFromURL("./assets/images/Tolo_Quote_Header_Left.png", 30, 60), "png", 0, 0, 60, 30, "headerleft", "NONE", 0);
    //  doc.addImage(getBase64ImageFromURL("./assets/images/Tolo_Quote_Header_Right.png", 30, 60), "png", 150, 0, 60, 30, "headerright", "NONE", 0);
    //  doc.text("Your Trusted Partner Where Motion Matters", 0, 35, {}, null);
    //  doc.text("Quotation #: " + CurrentQuote.QuoteNumber, 0, 40, {}, null);
    //  doc.text("Date: " + GetDateString() + " * " + "Time: " + GetTime(), 160, 35, {}, null);
    //  doc.line(0, 40, 200, 40);
    //  return [];
    //});

    //BuildReportContent(pdfGen);

    var pageHeight = pdfGen.internal.pageSize.getHeight();
    var pageWidth = pdfGen.internal.pageSize.getWidth();
    var font = pdfGen.getFont();


    //Quote/Customer/Header info

    pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
    pdfGen.setFontSize(10);
    pdfGen.text("Company Name:", 3, 38);
    pdfGen.text("Project:", 3, 48);
    pdfGen.text("Description:", 3, 58);
    pdfGen.text("Territory:", 90, 38);
    pdfGen.text("RSM:", 90, 48);
    pdfGen.text("AE:", 90, 58);
    pdfGen.text("Effective Date:", 150, 38);
    pdfGen.text("Expiration Date:", 150, 48);
    pdfGen.text("Prep. By:", 150, 58);

    pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
    pdfGen.text(SelectedCustomer, 32, 38, { maxWidth: 58 });    
    pdfGen.text(CurrentQuote.ProjectName, 17, 48, { maxWidth: 65 });    
    pdfGen.text(CurrentQuote.Description, 24, 58, { maxWidth: 64 });
    //    pdfGen.text(SelectedCustomer.Country, 18, 62);
    pdfGen.text(SelectedTerritory, 106, 38, { maxWidth: 47 });    
    pdfGen.text(SelectedRSM, 100, 48, { maxWidth: 53 });    
    pdfGen.text(CurrentQuote.AE, 97, 58, { maxWidth: 56 });
    pdfGen.text(new Date(CurrentQuote.EffectiveDate).toLocaleDateString(navigator.language), 175, 38, { maxWidth: pageWidth - 170 });    
    pdfGen.text(new Date(CurrentQuote.ExpirationDate).toLocaleDateString(navigator.language), 177, 48, { maxWidth: pageWidth - 172 });    
    pdfGen.text(CurrentQuote.TakenBy, 167, 58, { maxWidth: pageWidth - 162 });

    pdfGen.setDrawColor("#0079C2");
    pdfGen.setFillColor("#0079C2");
    pdfGen.rect(5, 65, (pageWidth * 0.66) - 5, 1, "F");
    pdfGen.setDrawColor("#8BC34A");
    pdfGen.setFillColor("#8BC34A");
    pdfGen.rect(pageWidth * 0.66, 65, (pageWidth * 0.33) - 5, 1, "F");

    //Quote Lines
    var CurrentPageY = 70;

    CurrentQuote.QuoteDetails.forEach(detail => {
      pdfGen.setFont(font.postScriptName, "bold");
      //check if we need to start a new page
      var isNewPage = false;
      if (pageHeight - 12 - 50 < CurrentPageY) {
        pdfGen.addPage();
        CurrentPageY = 32;
        isNewPage = true;
      }

      var dynamicSection = 40;
      var dynamicPricingSection = 15;
      if (detail.BreakQty2 > 0) {
        dynamicPricingSection += 5;
      }
      if (detail.BreakQty3 > 0) {
        dynamicPricingSection += 5;
      }
      if (detail.BreakQty4 > 0) {
        dynamicPricingSection += 5;
      }
      if (detail.BreakQty5 > 0) {
        dynamicPricingSection += 5;
      }
      if (dynamicSection > dynamicPricingSection) {
        if (detail.AssemblyDetailsDB.length > 650) {
          //need to increase height of dynamic section
          dynamicSection += Math.ceil(detail.AssemblyDetailsDB.length / 100.0) * 3;
        }
      } else {
        dynamicSection = dynamicPricingSection;
      }
      


      //check again for new page
      if (!isNewPage && pageHeight - 12 - 50 - dynamicSection < CurrentPageY) {
        pdfGen.addPage();
        CurrentPageY = 32;
        isNewPage = true;
      }

      //detail header
      pdfGen.setFillColor("#CCE8FF");
      pdfGen.setDrawColor("#000000");
      pdfGen.rect(5, CurrentPageY, pageWidth - 10, 10, "FD");
      CurrentPageY += 6;
      pdfGen.text("Line", 18, CurrentPageY);
      pdfGen.text("Part Number", 90, CurrentPageY);
      pdfGen.text("Estimated Lead Time", 160, CurrentPageY);

      //detail data
      CurrentPageY += 4;
      var pricingY = CurrentPageY + 10;
      pdfGen.rect(5, CurrentPageY, 30, 10, "S");
      pdfGen.rect(35, CurrentPageY, 120, 10, "S");
      pdfGen.rect(155, CurrentPageY, pageWidth - 160, 10, "S");
      CurrentPageY += 5;
      pdfGen.text(detail.QuoteLine.toString(), 20, CurrentPageY);
      //pdfGen.text((detail.ConfigString + detail.Item), 95 - ((detail.ConfigString + detail.Item).length / 2.0), CurrentPageY, {align:"center"});
      pdfGen.text((detail.ConfigString + detail.Item), (pageWidth / 2) - 10 , CurrentPageY, { align: "center", maxWidth:115 });
      pdfGen.text(detail.EstimatedLeadTimeString, 170, CurrentPageY);
      CurrentPageY += 10;

      //assembly details and product notes
      
      pdfGen.rect(5, pricingY, pageWidth - 50, dynamicSection, "S");
      CurrentPageY += 10;
      pdfGen.setFont(font.postScriptName, "underline", "normal");
      var assDetailX = 35;
      var prodNotesX = 110;
      if (detail.ProductNotes == "") {
        prodNotesX = 0;
        assDetailX = 72;
      }
      pdfGen.text("Assembly Details", assDetailX, pricingY + 8);

      if (prodNotesX > 0) {
        pdfGen.text("Product Notes", prodNotesX, pricingY + 8);
      }
      //    CurrentPageY += 10;
      pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");

      if (detail.LineType == "sp") {
        //SP line, only has one assembly detail
        var assDetailText = "";
        if (detail.AssemblyDetails.length == 0) {
          assDetailText = detail.AssemblyDetailsDB;
        } else {
          assDetailText = detail.AssemblyDetails[0];
        }
        pdfGen.text(assDetailText, 10, CurrentPageY);
        if (prodNotesX > 0) {
          pdfGen.text(detail.ProductNotes, 90, CurrentPageY);
        }
        

        //Add SP Note
        pdfGen.rect(8, CurrentPageY + 20, 150, 13, "S");
        pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
        pdfGen.text("Note:", 11, CurrentPageY + 25);
        pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
        pdfGen.text("This part number is a temporary code for ordering purposes.", 20, CurrentPageY + 25);
        pdfGen.text("Order must be revised once a permanent 8-digit part number is assingned by Tolomatic", 20, CurrentPageY + 29);

      } else if (detail.LineType == "cl") {
        //Configured Line, may have multiple assembly detail
        var colXArray = [];
        pdfGen.setFontSize(7);
        if (prodNotesX > 0) {
          colXArray = [8, 55];
          pdfGen.text(detail.ProductNotes, 100, CurrentPageY);
        } else {
          colXArray = [20,67]
        }
        
        var curRow = 0;
        var curCol = 0;
        
        var totalColumns = this.GetAssDetailColumnCount(detail);
        var assDetailColWidth = totalColumns == 1 ? 90 : 45;
        for (curCol; curCol < totalColumns; curCol++) {
          var assY = CurrentPageY;
          curRow = 0;
          for (curRow; curRow < this.GetAssDetailRowCount(detail); curRow++) {
            var detailText = this.GetAssDetailContent(detail, curRow, curCol);
            var detailTextLength = pdfGen.getTextWidth(detailText);
            pdfGen.text(detailText, colXArray[curCol], assY, { maxWidth: assDetailColWidth });
            if (detailTextLength > 90) {
              var YMultiplier = Math.ceil(detailTextLength / 90.0);
              if (YMultiplier > 1) {
                assY += (6 * YMultiplier);
              } else {
                assY += 6;
              }

            } else {
              assY += 6;
            }
            
          }
        }
        //for (curRow; curRow < this.GetAssDetailRowCount(detail); curRow++) {


        //  for (curCol; curCol < totalColumns; curCol++) {
        //    var detailText = this.GetAssDetailContent(detail, curRow, curCol);
        //    var detailTextLength = pdfGen.getTextWidth(detailText);

        //    pdfGen.text(detailText, colXArray[curCol], assY, { maxWidth: assDetailColWidth });

        //  }
        //  curCol = 0;
        //  assY += 6;
        //}

      } else {
        //anything else
        //SP line, only has one assembly detail
        var assDetailText = "";
        if (detail.AssemblyDetails.length == 0) {
          assDetailText = detail.AssemblyDetailsDB;
        } else {
          assDetailText = detail.AssemblyDetails[0];
        }
        pdfGen.text(assDetailText, 10, CurrentPageY);
        if (prodNotesX > 0) {
          pdfGen.text(detail.ProductNotes, 90, CurrentPageY);
        }
        
      }

      //pricing
      pdfGen.setFontSize(10);
      //pdfGen.setFillColor("#CCE8FF");
      //pdfGen.setDrawColor("#000000");
      //pdfGen.rect(pageWidth - 45, pricingY, 20, 12, "FD");
      //pdfGen.rect(pageWidth - 25, pricingY, 20, 12, "FD");
      //pricingY += 5;
      //pdfGen.text(["List Price", "(EA)"], pageWidth - 35, pricingY, { align: "center" });
      //pdfGen.text(formatCurrency(detail.ListPrice, navigator.language, "$"), (pageWidth - 7), pricingY + 1, { align:"right"});

      //pricingY += 7;
      pdfGen.rect(pageWidth - 45, pricingY, 20, 8);
      pdfGen.rect(pageWidth - 25, pricingY, 20, 8);

      pricingY += 5
      pdfGen.text("QTY", pageWidth - 38, pricingY);
      pdfGen.text("Unit Price", pageWidth - 22, pricingY);

      var breakQtyHeight = 10;
      if (detail.BreakQty2 > 0) {
        breakQtyHeight += 10;
      }
      if (detail.BreakQty3 > 0) {
        breakQtyHeight += 10;
      }
      if (detail.BreakQty4 > 0) {
        breakQtyHeight += 10;
      }
      if (detail.BreakQty5 > 0) {
        breakQtyHeight += 10;
      }
      pricingY += 3;

      var breakQtySection =dynamicSection - 28 ;// 22;
      //if (dynamicSection > 50) {
      //  breakQtySection = dynamicSection - 28;
      //}
      pdfGen.rect(pageWidth - 45, pricingY, 20, breakQtySection);
      pdfGen.rect(pageWidth - 25, pricingY, 20, breakQtySection);
      var linkY = pricingY + breakQtySection;
      pricingY += 5;

      pdfGen.text(this.GetBreakQtyString(detail, 0), pageWidth - 38, pricingY);
      var price1 = formatCurrency(parseFloat(this.GetBreakPrice(detail, 0, true)), navigator.language, "$"); 
      pdfGen.text(price1, pageWidth - 6, pricingY, {align:"right"});

      if (detail.BreakQty2 > 0) {
        pricingY += 5;
        pdfGen.text(this.GetBreakQtyString(detail, 1), pageWidth - 38, pricingY);
        var price2 = formatCurrency(parseFloat(this.GetBreakPrice(detail, 1, true)), navigator.language, "$"); 
        pdfGen.text(price2, pageWidth - 6, pricingY, { align: "right" });
      }
      if (detail.BreakQty3 > 0) {
        pricingY += 5;
        pdfGen.text(this.GetBreakQtyString(detail, 2), pageWidth - 38, pricingY);
        var price3 = formatCurrency(parseFloat(this.GetBreakPrice(detail, 2, true)), navigator.language, "$"); 
        pdfGen.text(price3, pageWidth - 6, pricingY, { align: "right" });
      }
      if (detail.BreakQty4 > 0) {
        pricingY += 5;
        pdfGen.text(this.GetBreakQtyString(detail, 3), pageWidth - 38, pricingY);
        var price4 = formatCurrency(parseFloat(this.GetBreakPrice(detail, 3, true)), navigator.language, "$"); 
        pdfGen.text(price4, pageWidth - 6, pricingY, { align: "right" });
      }
      if (detail.BreakQty5 > 0) {
        pricingY += 5;
        pdfGen.text(this.GetBreakQtyString(detail, 4), pageWidth - 38, pricingY);
        var price5 = formatCurrency(parseFloat(this.GetBreakPrice(detail, 4,true)), navigator.language, "$"); 
        pdfGen.text(price5, pageWidth - 6, pricingY, { align: "right" });
      }
      pdfGen.rect(pageWidth - 45, linkY, 40, 8, "S");
      if (detail.ProductURL != "") {
        var prodUrl = detail.ProductURL;
        pdfGen.textWithLink("Link to " + this.GetItemCode(detail), pageWidth - 38, linkY + 6, { URL: prodUrl });
        pdfGen.link(pageWidth - 45, linkY, 40, 8, { url: prodUrl });
      }
      CurrentPageY += (linkY - CurrentPageY) + 15;
    });

    //Fees
    if (CurrentQuote.QuoteFees != null && CurrentQuote.QuoteFees.length > 0) {
      //check if we need to start a new page
      if (pageHeight - 12 - (CurrentQuote.QuoteFees.length * 12) < CurrentPageY) {
        pdfGen.addPage();
        CurrentPageY = 32;
      }
      CurrentPageY += 5;
      pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
      pdfGen.setFontSize(20);
      pdfGen.text("Fees", 10, CurrentPageY);
      CurrentPageY += 5;
      //Fee header row
      pdfGen.setFontSize(10);
      pdfGen.setFillColor("#CCE8FF");
      pdfGen.setDrawColor("#000000");
      pdfGen.rect(5, CurrentPageY, pageWidth - 10, 10, "FD");
      CurrentPageY += 5;
      pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
      pdfGen.text("Fee", 20, CurrentPageY);
      pdfGen.text("Description", 95, CurrentPageY);
      pdfGen.text("QTY", 173, CurrentPageY);
      pdfGen.text("Total Cost", 186, CurrentPageY);
      pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
      CurrentPageY += 5;
      //Fee detail rows
      CurrentQuote.QuoteFees.forEach(fee => {
        //check again if we need to start a new page

        pdfGen.rect(5, CurrentPageY, 40, 10);
        pdfGen.rect(45, CurrentPageY, 125, 10);
        pdfGen.rect(170, CurrentPageY, 12, 10);
        pdfGen.rect(182, CurrentPageY, 23, 10);

        CurrentPageY += 5;
        pdfGen.text(fee.FeeName, 20 - (fee.FeeName.length / 2.0), CurrentPageY);
        pdfGen.text(fee.Description, 100 - (fee.Description.length / 2), CurrentPageY);
        pdfGen.text(fee.Qty.toString(), 176, CurrentPageY);
        pdfGen.text(formatCurrency(fee.UnitPrice * fee.Qty, navigator.language, "$"), 188, CurrentPageY);
      });
      CurrentPageY += 15;
    }

    //Quote notes
    //check if we need to start a new page
    if (pageHeight - 60 < CurrentPageY) {
      pdfGen.addPage();
      CurrentPageY = 35;
    }
    pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
    pdfGen.text("Note:", 5, CurrentPageY);
    pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
    CurrentPageY += 5;
    pdfGen.text(["• Quotation number must appear on all orders",
      "• This quote supersedes all previous quotations",
      "• Standard payment is NET 30 days unless otherwise specified",
      "• Tolomatic Inc. standard terms and conditions for sale apply",
      "• Written quotations not appearing on this form automatically expire in 30 days unless otherwise specified in writing",
      "• Verbal quotations expire same day",
      "• Item images are for reference only and are not exact to each configuration",
      "• All prices are in USD"
    ], 7, CurrentPageY);
    CurrentPageY += 35;

    //Direct Order Steps
    //pdfGen.setFont(font.postScriptName, font.fontStyle, "italic");
    if (CustType.indexOf("H") == 0) {
      //Check if we need to start a new page
      if (pageHeight - 60 < CurrentPageY) {
        pdfGen.addPage();
        CurrentPageY = 32;
      }
      pdfGen.setDrawColor("#CCE8FF");
      pdfGen.rect(5, CurrentPageY, pageWidth - 10, 50, "S");
      pdfGen.setDrawColor("#000000");
      CurrentPageY += 5;
      pdfGen.setFont(font.postScriptName, "bold");
      pdfGen.text("Direct Order Steps:", 10, CurrentPageY);
      CurrentPageY += 8;
      //pdfGen.setFont(font.postScriptName, font.fontStyle, "");
      pdfGen.setFont(font.postScriptName, "italic");
      pdfGen.text("Direct orders will need to be made with a credit card unless communicated otherwise.  Please follow the steps below.", 10, CurrentPageY);
      CurrentPageY += 5;
      pdfGen.text("You will need to send all purchase orders to ", 10, CurrentPageY);
      pdfGen.setFont(font.postScriptName, "bold");
      pdfGen.textWithLink("orders@tolomatic.com", 79, CurrentPageY, { URL: "mailto:orders@tolomatic.com" });
      //pdfGen.setFont(font.postScriptName, font.fontStyle, "");
      pdfGen.setFont(font.postScriptName, "italic");
      CurrentPageY += 7;
      pdfGen.text("If you could provide the below information, our team will call you shortly to get the credit card information", 10, CurrentPageY);
      CurrentPageY += 7;
      pdfGen.text(["• a PO or a detailed list of the items and amount needed",
        "• ship to address",
        "• shipping method",
        "• full billing address",
        "• contact name and email address"], 10, CurrentPageY);
    }
    //header and footer
    const totalPages = pdfGen.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdfGen.setPage(i);
      //Header Section
      pdfGen.setFontSize(40);

      pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
      pdfGen.setTextColor("#0D79BB");
      pdfGen.text("Tolo", 5, 15);

      pdfGen.setTextColor("#000000");
      pdfGen.text("matic", 35, 15);
      pdfGen.text("Quotation", pageWidth - 70, 15);

      pdfGen.setFontSize(4);
      pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
      pdfGen.text("TM", 70, 8);

      pdfGen.setFontSize(8);
      pdfGen.setTextColor("#0D79BB");
      pdfGen.text("Your Trusted Partner Where Motion Matters", 10, 20);

      pdfGen.setFontSize(12);
      pdfGen.setTextColor("#000000");
      pdfGen.setFont(font.postScriptName, font.fontStyle, "bold");
      pdfGen.text("Quote Number: " + CurrentQuote.QuoteNumber, 3, 28);

      pdfGen.setFontSize(8);
      pdfGen.setFont(font.postScriptName, font.fontStyle, "normal");
      pdfGen.text("Date: " + this.GetDateString() + " • " + "Time: " + this.GetTime(), pageWidth - 50, 28);

      if (i > 1) {
        pdfGen.setDrawColor("#0079C2");
        pdfGen.setFillColor("#0079C2");
        pdfGen.rect(5, 30, (pageWidth * 0.66) - 5, 1, "F");
        pdfGen.setDrawColor("#8BC34A");
        pdfGen.setFillColor("#8BC34A");
        pdfGen.rect(pageWidth * 0.66, 30, (pageWidth * 0.33) - 5, 1, "F");
      } else {
        pdfGen.line(5, 32, pageWidth - 5, 32);
      }
      //End Header Section

      //Footer section

      pdfGen.setFontSize(8);
      pdfGen.setTextColor("#777777");

      pdfGen.line(5, pageHeight - 10, pageWidth - 5, pageHeight - 10);
      pdfGen.setTextColor("#000000");
      pdfGen.setFont('Newsreader');
      pdfGen.text('3800 County Road 115 • Hamel MN 55340-9360 • USA',
        5,
        pageHeight - 5
      );
      pdfGen.text(
        `T: +1 (763)-296-7745`,
        pageWidth / 2.0,
        pageHeight - 5,
        { align: 'center' }
      );
      pdfGen.textWithLink('E: Orders@tolomatic.com',
        pageWidth - 35,
        pageHeight - 5,
        { url: "mailto:orders@tolomatic.com" }
      );
      //End Footer section
    }

    pdfGen.save(CurrentQuote.QuoteNumber);
  }

  GetAssDetailColumnCount(detail: QuoteDetail): number {
    if (detail.AssemblyDetails != null) {
      if (detail.AssemblyDetails.length <= 5) {
        return 1;
      }
      else {
        return 2;
      }
    }
    else {
      return 1;
    }
  }

  GetAssDetailRowCount(detail: QuoteDetail): number {
    if (detail.AssemblyDetails != null) {
      return Math.ceil(detail.AssemblyDetails.length / this.GetAssDetailColumnCount(detail));
    } else {
      return 0;
    }

  }

  GetAssDetailContent(detail: QuoteDetail, row: number, col: number) {
    var startIndex = row + (col * this.GetAssDetailRowCount(detail));

    if (detail.LineType != "sp") {
      if (startIndex > detail.AssemblyDetails.length - 1) {
        return "";
      }
      else {
        return this.stripTags(detail.AssemblyDetails.slice(startIndex, startIndex + 1)[0]);
      }
    }
    else {
      return detail.AssemblyDetails[0];
    }
  }


  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }



  GetDateString(): string {
    var curDate = new Date();
    return curDate.toLocaleDateString(navigator.language);
  }
  GetTime(): string {
    var curDate = new Date();
    return curDate.toLocaleTimeString(navigator.language);
  }

  public GetBreakPrice(detail: QuoteDetail, level: number, isV2: boolean): string {
    var retString = "";
    switch (level) {
      case 0:
        if (detail.BreakQty1 > 0 && detail.ListPrice > 0.0 && isV2) {
          retString = (detail.ListPrice + ((detail.BreakPrice1 / 100.00) * detail.ListPrice)).toFixed(2)
        }
        else if (!detail.IsV2) {
          retString = detail.UnitPrice1.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 1:
        if (detail.BreakQty2 > 0 && detail.ListPrice > 0.0 && isV2) {
          retString = (detail.ListPrice + ((detail.BreakPrice2 / 100.00) * detail.ListPrice)).toFixed(2)
        }
        else if (!detail.IsV2) {
          retString = detail.UnitPrice2.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 2:
        if (detail.BreakQty3 > 0 && detail.ListPrice > 0.0 && isV2) {
          retString = (detail.ListPrice + ((detail.BreakPrice3 / 100.00) * detail.ListPrice)).toFixed(2)
        }
        else if (!detail.IsV2) {
          retString = detail.UnitPrice3.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 3:
        if (detail.BreakQty4 > 0 && detail.ListPrice > 0.0 && isV2) {
          retString = (detail.ListPrice + ((detail.BreakPrice4 / 100.00) * detail.ListPrice)).toFixed(2)
        }
        else if (!detail.IsV2) {
          retString = detail.UnitPrice4.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 4:
        if (detail.BreakQty5 > 0  && detail.ListPrice > 0.0 && isV2) {
          retString = (detail.ListPrice + ((detail.BreakPrice5 / 100.00) * detail.ListPrice)).toFixed(2)
        } else if (!detail.IsV2) {
          retString = detail.UnitPrice5.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      default:
        retString = "0.0";
        break;
    }
    return retString;
  }

  public GetBreakQtyString(detail: QuoteDetail, level: number): string {
    var QtyMessage = "";
    if (level == 0 && detail.BreakQty1 > 0) {
      QtyMessage = detail.BreakQty1 + (detail.BreakQty2 > 0 ? "-" + (detail.BreakQty2 - 1).toString() : "+");
    } else if (level == 1 && detail.BreakQty2 > 0) {
      QtyMessage = detail.BreakQty2 + (detail.BreakQty3 > 0 ? "-" + (detail.BreakQty3 - 1).toString() : "+");
    } else if (level == 2 && detail.BreakQty3 > 0) {
      QtyMessage = detail.BreakQty3 + (detail.BreakQty4 > 0 ? "-" + (detail.BreakQty4 - 1).toString() : "+");
    } else if (level == 3 && detail.BreakQty4 > 0) {
      QtyMessage = detail.BreakQty4 + (detail.BreakQty5 > 0 ? "-" + (detail.BreakQty5 - 1).toString() : "+");
    } else if (level == 4 && detail.BreakQty5 > 0) {
      QtyMessage = detail.BreakQty5 + "+";
    }
    return QtyMessage;
  }

  public GetItemCode(detail: QuoteDetail):string {
    var itemCode = "";
    if (detail.ConfigString != "") {
      var first2 = detail.ConfigString.substring(0, 2);
      var first3 = detail.ConfigString.substring(0, 3);
      var first4 = detail.ConfigString.substring(0, 4);
      switch (first3) {
        case "ACS":
        case "B3B":
        case "B3S":
        case "B3W":
        case "BC2":
        case "BC3":
        case "BC4":
        case "BCS":
        case "ERD":
        case "GSA":
        case "ICR":       
        case "IMX":
        case "MMC":
        case "MMK":
        case "MXB":
        case "MXE":
        case "MXP":
        case "NDB":
        case "NGS":
        case "NMB":
        case "NNR":
        case "NPR":
        case "NRE":
        case "NSB":
        case "PB2":
        case "RLS":
        case "RSA":
        case "RSH":
        case "RSX":
        case "RTB":
        case "SLS":
        case "SVC":
        case "TBD":
        case "TKB":
        case "TKS":
        case "TRA":
        case "TRS":
        case "CSM":
          itemCode = first3;
          break;
        case "IMA":
          if (first4 != "IMAS") {
            itemCode = first3;
          }
          else {
            itemCode = first4;
          }
          break;
        default:
          break;
      }
      if (itemCode == "") {
        switch (first2) {
          case "CA":
          case "CC":
          case "GD":
          case "IM":
          case "LS":
          case "MG":
          case "PB":
          case "RB":
          case "RK":
          case "SW":
          case "WS":
            itemCode = first2;
            break;
        }
      }
      return itemCode;
    }
  }
}
